import axios from "axios";
import { socketApiUrl,baseURL } from "../BaseURL";
import { io } from 'socket.io-client';





export function authHeader() {
    let user = JSON.parse(window.sessionStorage.getItem('accessToken'));
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token }; // returning an object
    } else {
        return {}; // returning an empty object if no user or token
    }
}


export function logoutFunction() {
    localStorage.removeItem('accessToken');
    
    window.location.replace('/login');
    window.location.reload()
}

export const headerForPublicAPI = new Headers({
    'Content-Type': 'application/json',
})


export const headerForPrivateAPI = new Headers({
    'Content-Type': 'application/json',
    'Authorization': authHeader().Authorization
})


// export const headerForPrivateAPI = () => {
//     const token = authHeader()['Authorization']; // Accessing Authorization property of the object returned by authHeader()
//     const headers = new Headers();
//     if (token) {
//         headers.append('Authorization', token); // Adding Authorization header if token exists
//     }
//     headers.append('Content-Type', 'application/json'); // Always add Content-Type
//     return headers;
// }


// export const headerForPrivateAPIFormData = new Headers({
//     'Content-Type': 'multipart/form-data',
//     'Authorization': authHeader().Authorization
// })

export const headerForPrivateMediaAPI = new Headers({
    "Content-Type": "multipart/form-data",
    'Authorization': authHeader().Authorization
})



// export const APIcallFunction = async (credentials) => {
//     // console.log("credentialscredentials",credentials)
//     const requestOptions = {
//         method: credentials.method,
//         headers: credentials.header,
//         body: JSON.stringify(credentials.body)
//     };

//     // https://profitplay-backend.vercel.app/
//     // localhost:8804
//     try {
//         const response = await fetch("http://localhost:8804/api/v1" + credentials.endPoint, requestOptions);

//         const responseData = await handleResponse(response);

//         return {
//             data: responseData.data||responseData.message
//         };
//     } catch (error) {
//         console.error('Error:', error);
//         throw error;
//     }
// };
export const APIcallFunction = async (credentials) => {
    const requestOptions = {
        method: credentials.method,
        headers: credentials.header,
        body: JSON.stringify(credentials.body)
    };
    try {
        const response = await fetch(`${baseURL}/v1${credentials.endPoint}`, requestOptions);

        const responseData = await handleResponse(response);

        return {
            data: responseData.data
        };
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const APIcallFunctionForImage = async (credentials) => {
    try {
        const endpointUrl = `${baseURL}` + credentials.endPoint;
        const headers = {
            'Authorization': authHeader().Authorization,
            'Content-Type': 'multipart/form-data'
        };
        const response = await axios.post(endpointUrl, credentials.body, { headers });

        return {
            data: response.data
        };
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);

        // console.log(data);

        if (!response.ok) {
            if (response.status === 401) {
                logoutFunction();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        if (data.error) {
            if (data.code === 3) {
                logoutFunction();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}






let socket = null;

const initializeSocket = () => {
    socket = io(socketApiUrl, {
        autoConnect: false,
    });
};


export const reconnectSocket = () => {
    initializeSocket();
};

export const socketConnection = () => {
    if (!socket) {
        initializeSocket()
    }
    if (socket && !socket.connected) {
        socket.connect()
    }
    return socket
};



export const getMediaType = (url) => {
    if (!url) return null;

    // Extract file extension
    const extension = url.split('.').pop().toLowerCase();

    // Image extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];

    // Video extensions
    const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'ogg'];

    if (imageExtensions.includes(extension)) {
        return 'image';
    } else if (videoExtensions.includes(extension)) {
        return 'video';
    }

    return null; // Unknown type
};